export const ERROR409_MSG = 'You already ordered';
export const WRONG_EMAIL = 'Invalid email, try again';
export const ERROR_FETCH = 'Sorry! Something is wrong';
export const NO_EMAIL = 'Please, enter email';
export const NO_COMMENT = 'Please, enter comment';
export const KEY_CODE_ESC = 'Escape';

export const EMAIL_PATERN = '^[w-]+(.[w-]+)*@([w-]+.)+[a-zA-Z]{2,7}$';
